export default __webpack_public_path__ + "static/media/FFT.efedf42d.png";